// 'family' is used internally in the web wizard UI.
// 'user' is the canonical Firestore value written by both mobile and web.
// Both values represent a parent/family account — always use isParentAccount() for checks.
export type AccountType = 'family' | 'user' | 'host' | 'coach';

/** Returns true for any parent/family account regardless of which value was stored. */
export const isParentAccount = (accountType: string | undefined | null): boolean =>
    accountType === 'family' || accountType === 'user';

export interface AccountTypeOption {
  type: AccountType;
  icon: string;
  title: string;
  description: string;
  color: string;
}

export const accountTypes: AccountTypeOption[] = [
  {
    type: 'family',
    icon: 'account-group',
    title: 'Family Account',
    description: 'Register your children for camps and manage their activities',
    color: '#3C8248',
  },
  {
    type: 'host',
    icon: 'home-city',
    title: 'Camp Host',
    description: 'Create and manage your own camp programs',
    color: '#2196F3',
  },
  {
    type: 'coach',
    icon: 'whistle',
    title: 'Coach Account',
    description: 'Lead sessions and work with camp programs',
    color: '#FF9800',
  },
];

